import {Component, Inject} from '@angular/core';
import {Role} from "../../../../dip/role";
import {AbstractProdForm, ProdFormField, ProdFormFieldType, ProdFormValidators, RequiredValidator} from 'prod-form';
import {ProdGridColumnType} from 'prod-grid';
import {ProdDialogData} from 'prod-dialog';
import {UserService} from "../../../../services/user.service";
import {DipColumn} from "../../../../dip/dip-column";
import {PermissionService} from "../../../../services/permission.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrganizationUserGroupService} from "../../../../services/organization-user-group.service";
import {RoleService} from "../../../../services/role.service";
import {HttpFilterParam} from 'prod-shared';
import {TranslateService} from "@ngx-translate/core";


@Component({
  selector: 'app-distributor-group-form',
  templateUrl: './distributor-group-form.component.html'
})
export class DistributorGroupFormComponent extends AbstractProdForm {
  title: string = this.translate.instant('distributor.groups.form.title');
  private isFieldsEditable: boolean = this.roleService.hasRole([Role.ROLE_DISTRIBUTOR_ADMIN]);
  fields: ProdFormField[] = [
    ProdFormField.create({
      name: 'userGroup_name',
      label: this.translate.instant('distributor.groups.form.name'),
      type: ProdFormFieldType.TEXT,
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'userGroup_description',
      label: this.translate.instant('distributor.groups.form.description'),
      type: ProdFormFieldType.TEXTAREA,
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'userGroup_users',
      label: this.translate.instant('distributor.groups.form.users'),
      type: ProdFormFieldType.GRID,
      gridParameter: {
        service: UserService,
        displayColumn: DipColumn.get({property: 'username', type: ProdGridColumnType.STRING}),
        extraColumns: [
          DipColumn.get({property: 'firstName', type: ProdGridColumnType.STRING}),
          DipColumn.get({property: 'lastName', type: ProdGridColumnType.STRING}),
        ]
      },
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'permissions',
      label: this.translate.instant('distributor.groups.form.permissions'),
      type: ProdFormFieldType.GRID,
      gridParameter: {
        service: PermissionService,
        displayColumn: DipColumn.get({property: 'name', type: ProdGridColumnType.STRING}),
        extraColumns: [
          DipColumn.get({property: 'description', type: ProdGridColumnType.STRING}),
        ],
        filter: new HttpFilterParam({
          property: 'module',
          operator: 'in',
          value: ['distributor']
        })
      },
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'organization',
      label: null,
      type: ProdFormFieldType.HIDDEN,
      isEditable: this.isFieldsEditable
    }),
  ]

  constructor(
    dialogRef: MatDialogRef<DistributorGroupFormComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: ProdDialogData,
    override dataService: OrganizationUserGroupService,
    private roleService: RoleService,
    private translate: TranslateService) {
      super();
  }

  ngOnInit() {
    this.fields.forEach(field => {
      if (field.name === 'userGroup_users') field.gridParameter.filter = new HttpFilterParam({
        property: 'groups.organizationUserGroup.organization',
        operator: 'eq',
        value: this.data.extraData.distributor
      });
      if (field.name === 'organization') field.value = this.data.extraData.distributor;
    })
  }
}
